import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/character/:characterName",
    name: "Character",
    // route level code-splitting
    // this generates a separate chunk (user.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "user" */ "../views/Character.vue")
  },
  {
    path: "/guilds/:guildName",
    name: "Guild",
    component: () =>
      import("../views/GuildDetailPage.vue")
  },
  {
    path: "/timers",
    name: "Timers",
    component: () =>
      import("../views/Timers.vue")
  },
  {
    path: "/leaderboards",
    name: "Leaderboard",
    component: () =>
      import("../views/Leaderboard.vue")
  }
];

const router = new VueRouter({
  routes
});

export default router;
